import React from "react";
import { Navigate } from "react-router-dom";
import { useCurrentUser, useRefreshUser } from "redux/user";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const user = useCurrentUser();
    const refreshUser = useRefreshUser();
    const googleId = user?.google_id;

    React.useEffect(() => {
        if (googleId) {
            refreshUser(googleId);
        }
    }, [googleId, refreshUser]);

    if (!user) return <Navigate to="/login" replace={true} />;

    return children;
};

export default ProtectedRoute;
